import React from 'react';
import { IndexRoute, Route, Router, browserHistory } from 'react-router';
import Login from './components/pages/login';
import Home from './components/pages/home';
import Topics from './components/pages/topics';
import Topic from './components/pages/topic';
import Conversations from './components/pages/conversations';
import Conversation from './components/pages/conversation';
import Logout from './components/pages/logout';
import Profile from './components/pages/profile';
import App from './components/app';
import { useApolloClient } from "@apollo/react-hooks";
import { getInitialMode } from './utils/utils';

const onEnter = (client)  => {
	return (nextState, replace, callback) => {
        client.writeData({ data : {
            theme: getInitialMode(), 
            language: { 
                language: Object.is(localStorage.getItem("lang"),'null') || !localStorage.getItem("lang") ? 'EN' : localStorage.getItem("lang"), 
                __typename: 'Language'
           } 
        }});
       
        // let connectedTime = localStorage.getItem('connectedTime');
        // if (
        //     (!localStorage.getItem('token') && !localStorage.getItem('expiresAt') )
        //     || (localStorage.getItem('token') && !localStorage.getItem('expiresToken2') )
        //     || (localStorage.getItem('token') && connectedTime && (new Date().getTime() - parseInt(connectedTime) > localStorage.getItem('expiresAt') * 1000))
        // ) {      
        //     replace('/logout');
        // }
            if (!localStorage.getItem('auth') && !localStorage.getItem('xToken')) {
                replace('/logout');
            } else if (localStorage.getItem('auth') && localStorage.getItem('xToken')) {
                localStorage.removeItem('auth');
            }
        callback();
    }
}

const onLoginEnter = ()  => {
	return (nextState, replace, callback) => {
        if (localStorage.getItem('xToken') && nextState.location.pathname === '/login') {
            replace('/');
        }

        localStorage.setItem("auth", true);
        callback();
    }
}

const Routes = () => {
    const client = useApolloClient();

    return (
        <Router history={browserHistory}>
            <Route path="/" onEnter={onEnter(client)} component={App}>
                <IndexRoute component={Home} />
                <Route path="/topics" component={Topics} />
                <Route path="/topics/:topicId" component={Topic} />
                <Route path="/conversations" component={Conversations}/>
                <Route path="/conversations/:id" component={Conversation} />
                <Route path="/profile" component={Profile} />
            </Route>
            <Route path="/login" onEnter={onLoginEnter()} component={Login}/>
            <Route path="/logout" component={Logout}/>
        </Router>
    ); 
}



export default Routes;
